import { withIconSVG, withInlineSVG } from '../../patterns/icons/svg-tools/generator/withInlineSVG'
import ExternalIconAsset from './assets/external-icon.svg'
// TODO: https://github.com/EVENFinancial/cro-fionacom-web/pull/990/files#r878252136
import ArrowRightAsset from './assets/arrow-right-icon.svg'
import ArrowLeftAsset from './assets/arrow-left-icon.svg'
import CloseIconAsset from './assets/close-icon.svg'
import PlusIconAsset from './assets/plus-icon.svg'

export const ExternalIcon = withIconSVG(ExternalIconAsset)
export const PlusIcon = withIconSVG(PlusIconAsset)

export const RightArrowIcon = withIconSVG(ArrowRightAsset)
export const LeftArrowIcon = withIconSVG(ArrowLeftAsset)

export const CloseIcon = withInlineSVG(CloseIconAsset)
